import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

import { FlexColumn } from '../../styled';

interface DriverAndVendorColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

export default function DriverAndVendorColumn({
  invoice,
  sx,
}: DriverAndVendorColumnProps) {
  const { job } = invoice;

  const driverName = job?.driver?.fullName ?? '-';
  const vendorName = job?.vendorJobAssignment?.vendorAccount?.name;

  return (
    <Box sx={sx}>
      <FlexColumn>
        <OverflowAwareText data-sentry-mask fontSize="inherit" fontWeight={700}>
          {driverName}
        </OverflowAwareText>

        <OverflowAwareText fontSize="inherit">{vendorName}</OverflowAwareText>
      </FlexColumn>
    </Box>
  );
}
